var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "#B7281E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64645 4.14645C4.84171 3.95118 5.15829 3.95118 5.35355 4.14645L9.5 8.29289L13.6464 4.14645C13.8417 3.95118 14.1583 3.95118 14.3536 4.14645C14.5488 4.34171 14.5488 4.65829 14.3536 4.85355L10.2071 9L14.3536 13.1464C14.5488 13.3417 14.5488 13.6583 14.3536 13.8536C14.1583 14.0488 13.8417 14.0488 13.6464 13.8536L9.5 9.70711L5.35355 13.8536C5.15829 14.0488 4.84171 14.0488 4.64645 13.8536C4.45118 13.6583 4.45118 13.3417 4.64645 13.1464L8.79289 9L4.64645 4.85355C4.45118 4.65829 4.45118 4.34171 4.64645 4.14645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1760a6068a4d9c36692679681a4907ba.svg";
export { ForwardRef as ReactComponent };